import {omit} from 'lodash'
import createModel from 'utils/model'
import {sessions, groupSessions, exportMessage} from 'message-control/services/message-monitor'

export default createModel({
    namespace: 'messageControl_messageMonitor',
    state: {
        activeSession: {}, // 选中的会话
        activeGroupSession: {}, // 选中的群会话
    },
    subscriptions: {},
    effects: {
        *sessions({payload}, {call}) {
            const query = {...payload}
            const params = {
                limit: payload.limit,
                offset: payload.offset,
            }
            const body = omit(query, ['limit', 'offset'])
            return yield call(sessions, {params, body})
        },
        *exportMessage({payload}, {call}) {
            return yield call(exportMessage, payload)
        },
        *groupSessions({payload}, {call}) {
            return yield call(groupSessions, payload)
        },
    },
    reducers: {},
})
